import { ENV_NAME } from './env';

export function isGrow() {
  const { pathname, hostname } = location;
  return (
    (ENV_NAME === 'development' && pathname.startsWith('/grow')) ||
    hostname.startsWith('grow.')
  );
}
